import { Component, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Transition } from '@uirouter/angular';

import {
    Training,
    TrainingService,
    TrainingUniverse,
    Universe,
} from '../../../_services';
import { JhiLanguageHelper } from '../../../shared';
import { TrainingPrice } from '../detail/location/price.component';
import { TrainingPriceService } from '../../../_services/training/location/price.service';

@Component({
    selector: 'jhi-training-create',
    templateUrl: '../detail/description/description.component.html',
    styleUrls: [
        '../detail/description/description.component.scss',
        'create.component.scss',
    ],
})
export class TrainingCreateComponent implements OnInit {
    trainingId: string;
    training: Training;
    universes: Universe[];
    partners: any;
    success = false;
    language = 'fr';
    selectedUniverses = [];
    creationMode = true;
    trainingUniverses: TrainingUniverse[] = [];

    constructor(
        private trainingService: TrainingService,
        private trainingPriceService: TrainingPriceService,
        private languageHelper: JhiLanguageHelper,
        private trans: Transition
    ) {
        this.training = <Training>{};
    }

    ngOnInit(): void {
        this.trainingService.getUniverses().subscribe((universes) => {
            this.universes = universes;
        });
        this.trainingService.getPartners().subscribe((partners) => {
            this.partners = partners;
        });

        this.training.universes = [];
        this.training.trainingUniverses = [];
        this.training.trainingPrices = [];
    }

    addNewUniverse() {
        this.training.trainingUniverses.push({ order: 0 });
    }

    removeUniverse(index: number) {
        this.training.trainingUniverses.splice(index, 1);
    }

    addNewCity() {
        this.trainingPriceService.addNewCity(this.training.trainingPrices);
    }

    removeCity(index: number) {
        this.trainingPriceService.removeCity(
            index,
            this.training.trainingPrices
        );
    }

    save(): void {
        const training = JSON.parse(JSON.stringify(this.training));
        training.price *= 100;
        training.language = this.language;
        training.universes = this.selectedUniverses.map((id) => {
            return {
                id,
            };
        });
        training.trainingPrices = this.training.trainingPrices.filter(
            (trainingPrice) =>
                trainingPrice.country &&
                trainingPrice.city &&
                trainingPrice.price &&
                trainingPrice.currencyCode
        );

        if (training.trainingPrices) {
            training.trainingPrices =
                this.trainingPriceService.formatTrainingPrices(
                    this.training.trainingPrices,
                    true
                );
        }
        if (training.partnerFees) {
            training.partnerFees = !isNaN(training.partnerFees)
                ? training.partnerFees * 100
                : null;
        }

        this.trainingService.create(training).subscribe((response) => {
            if (response !== null) {
                this.success = true;
                window.setTimeout(() => {
                    window.location.href = '#/training/' + response.id;
                }, 0);
            }
        });
    }

    change(country: string, item: TrainingPrice): void {
        this.trainingPriceService.setCountry(country, item);
    }

    getBoolTranslateKey(data: any): string {
        if (data) {
            return 'global.true';
        }
        return 'global.false';
    }

    trackByFn(index, item) {
        return index;
    }

    getUniverseName(trainingUniverse: TrainingUniverse) {
        return this.universes.find(
            (value) => value.id === trainingUniverse.universeId
        ).name;
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/training/create/create.component.ts